
document.querySelectorAll(".DisplayOrNot").forEach(div => {
        div.addEventListener("change",function () {
            const param= this.getAttribute("data-param");
            DisplayOrNot(param);
        });
    }
);

function DisplayOrNot(className) {

    const divs = document.querySelectorAll(`div.${className}`);

    if(!divs || divs.length ===0)
    {return;}

    divs.forEach(div => {

        if (div) {
            if (!div.classList.contains("hide-element"))
            {
                div.classList.add("hide-element");
            }
            else
            {
                div.classList.remove("hide-element");
            }
        }
    });

}

